import { IQueryOptions } from '@kurtosys/types/query/index.js';

export function isQueryOptionsObject(options: IQueryOptions): boolean {
	return !!(options && typeof options === 'object' && options.queryOptionsType !== undefined);
}
